import { render, staticRenderFns } from "./SettingAutoLikedSearchEdit.vue?vue&type=template&id=c0352f24"
import script from "./SettingAutoLikedSearchEdit.vue?vue&type=script&lang=js"
export * from "./SettingAutoLikedSearchEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports